// extracted by mini-css-extract-plugin
module.exports = {"Container":"ScanMethods_Container__4hco5","Title":"ScanMethods_Title__3c5Dl","CardsWrapper":"ScanMethods_CardsWrapper__1y1bL"};